<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    :return-value.sync="lazyValue"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateValue"
        prepend-inner-icon="mdi-calendar"
        readonly
        v-bind="$attrs"
        clearable
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      color="primary"
      v-model="lazyValue"
      :type="$attrs['dateType'] || 'date'"
      no-title
      scrollable
      :allowed-dates="allowedDates"
      @change="onDateChange"
      :min="minDate"
      :max="maxDate || $attrs['max']"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
      <v-btn text color="primary" @click="onSaveClick"> OK </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";

export default {
  name: "MenuDatepicker",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: null,
    shouldUseAllowedDates: {
      type: Boolean,
      default: () => true,
    },
    minDate: String,
    maxDate: String,
    displayFormat: {
      type: String,
      default: () => "DD/MM/Y",
    },
  },
  data() {
    return {
      menu: false,
      lazyValue: this.value,
    };
  },
  methods: {
    onSaveClick() {
      this.$emit("change", this.dateValue);
      this.$refs.menu.save(this.lazyValue);
    },
    onDateChange() {
      this.$emit("change", this.dateValue);
      this.$refs.menu.save(this.lazyValue);
    },
    allowedDates(val) {
      if (!this.shouldUseAllowedDates) return true;
      if (!this.minDate) return true;
      let formatDate = moment(this.minDate, "DD/MM/YYYY").format();
      let formatVal = moment(val, "YYYY/MM/DD").format();
      return moment(formatVal).isAfter(formatDate);
    },
  },
  computed: {
    dateValue: {
      get() {
        if (!this.lazyValue) return "";
        const parsedDate = moment(this.lazyValue);
        if (!parsedDate.isValid()) return "";
        return moment(this.lazyValue).format(this.displayFormat);
      },
      set(value) {
        this.lazyValue = value;
        this.$emit("change", this.dateValue);
        this.$refs.menu.save(this.lazyValue);
      },
    },
  },
};
</script>

<style scoped></style>
